const REVEAL = {
	startRatio: 0.92,
	endRatio: 0.55,
	translateY: 22,
	blur: window.matchMedia('(max-width: 859px)').matches ? 0 : 5,
	ease: 0.18,
};

document.documentElement.classList.add('is-enhanced');
const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
let prefersReducedMotion = motionQuery.matches;

const articles = [...document.querySelectorAll('.collection')];
const progressEl = document.getElementById('pageProgress');
// const heroPageNumEl = document.getElementById("heroPageNum");
const pageBgEl = document.getElementById('pageBg');
const sceneBgEl = document.getElementById('sceneBg');
const heroPageLeftEl = document.getElementById('heroPageLeft');
const navEl = document.getElementById('collectionNav');
const navLinks = [...navEl.querySelectorAll('.collection-dot')];

let scrollEl = null;
let lineEls = [];
let currentIndex = -1;
let switchTimer = null;
let rafId = null;

function onMotionPreferenceChange() {
	prefersReducedMotion = motionQuery.matches;
	requestTick();
}

if (typeof motionQuery.addEventListener === 'function') {
	motionQuery.addEventListener('change', onMotionPreferenceChange);
} else if (typeof motionQuery.addListener === 'function') {
	motionQuery.addListener(onMotionPreferenceChange);
}

function parseCollectionId() {
	const fromHash = location.hash.replace(/^#/, '');
	if (fromHash && articles.some((article) => article.id === fromHash)) {
		return fromHash;
	}

	const fromQuery = new URLSearchParams(location.search).get('id');
	if (fromQuery && articles.some((article) => article.id === fromQuery)) {
		return fromQuery;
	}

	return articles[0].id;
}

function indexFromId(id) {
	const index = articles.findIndex((article) => article.id === id);
	return index < 0 ? 0 : index;
}

function onScroll() {
	updateProgress();
	requestTick();
}

function bindScroll(el) {
	if (scrollEl) {
		scrollEl.removeEventListener('scroll', onScroll);
	}
	scrollEl = el;
	if (scrollEl) {
		scrollEl.addEventListener('scroll', onScroll, { passive: true });
	}
}

function splitBreaksIntoLines(article) {
	article.querySelectorAll('.passage p').forEach((p) => {
		if (p.dataset.brSplit === '1' || !p.querySelector('br')) return;

		const parts = [];
		let html = '';
		p.childNodes.forEach((node) => {
			if (node.nodeName === 'BR') {
				parts.push(html);
				html = '';
				return;
			}
			html += node.nodeType === Node.TEXT_NODE ? node.textContent : node.outerHTML;
		});
		parts.push(html);

		p.classList.remove('line');
		p.innerHTML = parts
			.map((part) => part.replace(/^\s+|\s+$/g, ''))
			.filter(Boolean)
			.map((part) => `<span class="line">${part}</span>`)
			.join('');
		p.dataset.brSplit = '1';
	});
}

function bindLines(article) {
	if (rafId != null) {
		cancelAnimationFrame(rafId);
		rafId = null;
	}

	bindScroll(article.querySelector('.text-scroll'));
	splitBreaksIntoLines(article);
	lineEls = [...article.querySelectorAll('.passage .line, .passage h3')].map((el) => {
		el.style.removeProperty('opacity');
		el.style.removeProperty('transform');
		el.style.removeProperty('filter');
		return { el, current: 0, target: 0 };
	});
	if (scrollEl) scrollEl.scrollTop = 0;
	updateProgress();
	requestTick();
}

function applyTheme(article, index) {
	const theme = article.dataset.theme || String(index);
	pageBgEl.className = 'page-bg theme-bg-' + theme;
	sceneBgEl.className = 'scene-bg scene-bg-' + theme;
	heroPageLeftEl.querySelectorAll('img').forEach((img) => {
		img.classList.toggle('is-active', img.dataset.collection === article.id);
	});
	// heroPageNumEl.textContent = String(index + 1).padStart(2, "0");
	pageBgEl.style.removeProperty('opacity');
	sceneBgEl.style.removeProperty('opacity');
	heroPageLeftEl.style.opacity = 1;
}

function updateNav(index) {
	navLinks.forEach((link, i) => {
		const active = i === index;
		link.classList.toggle('active', active);
		if (active) {
			link.setAttribute('aria-current', 'page');
		} else {
			link.removeAttribute('aria-current');
		}
	});
}

function setHeadingOpacity(article, value) {
	const heading = article.querySelector('.hero-heading');
	const photo = article.querySelector('.hero-photo-strip');
	if (heading) heading.style.opacity = value;
	if (photo) photo.style.opacity = value;
}

function showCollection(index) {
	articles.forEach((article, i) => {
		article.classList.toggle('is-active', i === index);
		if (i !== index) {
			setHeadingOpacity(article, '');
		}
	});

	const article = articles[index];
	setHeadingOpacity(article, 1);
	applyTheme(article, index);
	updateNav(index);
	bindLines(article);
}

function syncUrl(id, historyMode) {
	if (historyMode === 'none') return;

	const params = new URLSearchParams(location.search);
	params.delete('id');
	const query = params.toString();
	const next = location.pathname + (query ? '?' + query : '') + '#' + id;
	const current = location.pathname + location.search + location.hash;
	if (current === next) return;

	if (historyMode === 'replace') {
		history.replaceState({ id }, '', next);
	} else {
		history.pushState({ id }, '', next);
	}
}

function selectCollection(index, { historyMode = 'push', immediate = false } = {}) {
	if (index === currentIndex && !immediate) {
		if (scrollEl) scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
		return;
	}

	window.clearTimeout(switchTimer);
	const article = articles[index];
	syncUrl(article.id, historyMode);

	if (immediate || currentIndex < 0 || prefersReducedMotion) {
		currentIndex = index;
		showCollection(index);
		return;
	}

	const currentArticle = articles[currentIndex];
	currentIndex = index;

	setHeadingOpacity(currentArticle, 0);
	pageBgEl.style.opacity = 0;
	sceneBgEl.style.opacity = 0;
	heroPageLeftEl.style.opacity = 0;
	updateNav(index);

	switchTimer = window.setTimeout(() => {
		showCollection(index);
	}, 220);
}

function selectById(id, options) {
	selectCollection(indexFromId(id), options);
}

function computeTargetProgress(el, frameRect) {
	const rect = el.getBoundingClientRect();
	const h = frameRect.height;
	const startY = frameRect.top + h * REVEAL.startRatio;
	const endY = frameRect.top + h * REVEAL.endRatio;
	const raw = (startY - rect.top) / (startY - endY);
	return Math.min(1, Math.max(0, raw));
}

function getMaxScroll() {
	if (!scrollEl) return 0;
	return scrollEl.scrollHeight - scrollEl.clientHeight;
}

function isAtScrollEnd() {
	const maxScroll = getMaxScroll();
	if (maxScroll <= 1) return true;
	return scrollEl.scrollTop >= maxScroll - 2;
}

function updateProgress() {
	if (!progressEl || !scrollEl) return;
	const maxScroll = getMaxScroll();
	const ratio = maxScroll > 0 ? scrollEl.scrollTop / maxScroll : 0;
	progressEl.style.setProperty('--h', `${Math.round(ratio * 100)}%`);
}

function applyLineStyle(item, progress) {
	if (progress >= 0.999) {
		item.el.style.opacity = 1;
		item.el.style.transform = 'none';
		item.el.style.filter = 'none';
		return;
	}

	item.el.style.opacity = progress;
	item.el.style.transform = `translateY(${(1 - progress) * REVEAL.translateY}px)`;
	item.el.style.filter = REVEAL.blur === 0
	? 'none'
	: `blur(${(1 - progress) * REVEAL.blur}px)`;
}

function tick() {
	rafId = null;
	if (!scrollEl) return;

	const frameRect = scrollEl.getBoundingClientRect();
	const atEnd = isAtScrollEnd();
	let needsMore = false;

	lineEls.forEach((item) => {
		item.target = atEnd ? 1 : computeTargetProgress(item.el, frameRect);

		if (prefersReducedMotion) {
			item.current = item.target;
		} else {
			item.current += (item.target - item.current) * REVEAL.ease;
			if (Math.abs(item.target - item.current) < 0.001) item.current = item.target;
		}

		applyLineStyle(item, item.current);

		if (item.current !== item.target) {
			needsMore = true;
		}
	});

	if (needsMore) {
		rafId = requestAnimationFrame(tick);
	}
}

function requestTick() {
	if (rafId == null) {
		rafId = requestAnimationFrame(tick);
	}
}

document.addEventListener('click', (event) => {
	const link = event.target.closest('a[href^="#"]');
	if (!link) return;
	const id = (link.getAttribute('href') || '').replace(/^#/, '');
	if (!articles.some((article) => article.id === id)) return;
	event.preventDefault();
	selectById(id);
});

window.addEventListener('popstate', () => {
	selectById(parseCollectionId(), { historyMode: 'none' });
});

const MOBILE_MQ = window.matchMedia('(max-width: 859px)');

function syncSiteHeaderHeight() {
	if (!MOBILE_MQ.matches) {
		document.documentElement.style.removeProperty('--site-header-height');
		return;
	}

	const space = document.querySelector('.header__space');
	const wrapper = document.querySelector('.header__outer-wrapper');
	const height =
		(space ? space.getBoundingClientRect().height : 0) +
		(wrapper ? wrapper.getBoundingClientRect().height : 0);

	if (height > 0) {
		document.documentElement.style.setProperty('--site-header-height', `${height}px`);
	}
}

function onViewportChange() {
	syncSiteHeaderHeight();
	requestTick();
}

window.addEventListener('resize', onViewportChange);
if (typeof MOBILE_MQ.addEventListener === 'function') {
	MOBILE_MQ.addEventListener('change', onViewportChange);
} else if (typeof MOBILE_MQ.addListener === 'function') {
	MOBILE_MQ.addListener(onViewportChange);
}

if (typeof ResizeObserver === 'function') {
	const headerObserver = new ResizeObserver(syncSiteHeaderHeight);
	['.header__space', '.header__outer-wrapper'].forEach((selector) => {
		const el = document.querySelector(selector);
		if (el) headerObserver.observe(el);
	});
}

syncSiteHeaderHeight();
selectById(parseCollectionId(), { historyMode: 'replace', immediate: true });
window.scrollTo(0, 0);
